function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.226 23.11C1.226 12 10.226 3 21.336 3c9.326 0 17.155 6.336 19.443 14.944a.801.801 0 01-1.549.411c-2.105-7.924-9.313-13.753-17.895-13.753-10.225 0-18.507 8.282-18.507 18.508 0 3.055.74 5.934 2.047 8.466l.13.25-1.951 9.565 9.564-1.95.251.13a18.414 18.414 0 008.466 2.046.801.801 0 010 1.602c-3.215 0-6.255-.756-8.947-2.096L1 43.445l2.322-11.389a20.02 20.02 0 01-2.096-8.946z",
  fill: "#2D2D2D"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M43.373 29.85c-.984-5.89-6.558-9.868-12.45-8.883-5.89.985-9.867 6.558-8.883 12.45.985 5.89 6.559 9.868 12.45 8.883 1.102-.184 2.318-.691 3.403-1.291s1.97-1.255 2.414-1.68a.801.801 0 011.109 1.156c-.572.548-1.58 1.28-2.748 1.926-1.169.646-2.564 1.244-3.914 1.47-6.764 1.13-13.163-3.437-14.294-10.2-1.13-6.764 3.436-13.164 10.2-14.294 6.763-1.13 13.163 3.436 14.293 10.2a12.36 12.36 0 01-.615 6.398.801.801 0 01-1.5-.563c.645-1.72.86-3.627.535-5.571zm-.295 7.085c.38.227.504.719.277 1.099-.168.282-.343.55-.522.803a.801.801 0 01-1.307-.926c.155-.22.307-.452.453-.698a.801.801 0 011.099-.278z",
  fill: "#2D2D2D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M34.283 38.791a.966.966 0 10-1.93 0 .966.966 0 001.93 0z",
  fill: "#2D2D2D"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.265 26.003c-1.674 0-3.026 1.274-3.026 2.853v.9c0 .412-.354.746-.792.746-.437 0-.791-.334-.791-.746v-.9c0-2.403 2.06-4.346 4.609-4.346s4.609 1.943 4.609 4.346c0 2.148-1.647 3.929-3.817 4.282v2.917c0 .412-.355.746-.792.746-.438 0-.792-.334-.792-.746v-4.346h.792c1.674 0 3.025-1.275 3.025-2.853 0-1.579-1.351-2.853-3.025-2.853zM11.691 43.689c.09.41-.239.83-.736.94l-6 1.324c-.497.11-.973-.134-1.063-.543-.09-.41.239-.831.736-.94l6-1.325c.497-.11.973.134 1.063.544z",
  fill: "#2D2D2D"
});

function SvgComplexChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default __webpack_public_path__ + "/img/complex-chat.svg";
export { SvgComplexChat as ReactComponent };